// extracted by mini-css-extract-plugin
export default {"root":"IconBillCheck_root__5EPwP"};